import { render, staticRenderFns } from "./rolemanagement.vue?vue&type=template&id=230c578c&scoped=true&"
import script from "./rolemanagement.vue?vue&type=script&lang=js&"
export * from "./rolemanagement.vue?vue&type=script&lang=js&"
import style0 from "./rolemanagement.vue?vue&type=style&index=0&id=230c578c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230c578c",
  null
  
)

export default component.exports